<template>
    <div>
      <div>
            <h2 class="mb-4">{{$t('intern_rechnung_bezahlen.rechnung_title')}}</h2>

          <span>{{$t('intern_rechnung_bezahlen.rechnung_nr')}}</span> &#160; <span>{{this.invoice.rechnungsnummer}}</span>
            <br /><br />

          <span> {{$t('intern_rechnung_bezahlen.rechnung_betrag')}} </span> &#160; <span>{{this.invoice.total_brutto | currency}}</span>
            <br /><br />
      </div>
      <hr>
      <div v-if="sepaInfo">
            <div class="mb-4" v-html="$t('intern_rechnung_bezahlen.bankdaten_erforderlich')"></div>

            <div v-if="err != null" class="alert alert-danger" role="alert">
              {{this.err}}
            </div>
            <div class="row form-group">
              <div class="col-md-6 mb-4">
                    <span class="" v-html="$t('intern_bankdata.bank')"></span>
                    <input type="text" class="form-control" name="sepa[bank]" v-model.trim="bankname">
              </div>

              <div class="col-md-6">
                    <span class="" v-html="$t('intern_bankdata.owner')"></span>
                    <input type="text" class="form-control" name="sepa[owner]" v-model.trim="owner" @blur="$v.owner.$touch()" :class="{ 'is-invalid': $v.owner.$error }" >
                    <div class="invalid-feedback" v-if="!$v.owner.required">Bitte Konto-inhaber eingeben</div>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-6 mb-4">
                  <span class="" v-html="$t('intern_bankdata.bic')"></span>
                  <input type="text" class="form-control" name="sepa[bic]" v-model.trim="bic" @blur="$v.bic.$touch()" :class="{ 'is-invalid': $v.bic.$error }" >
                  <div class="invalid-feedback" v-if="!$v.bic.required">Bitte BIC eingeben</div>
              </div>

              <div class="col-md-6">
                  <span class="" v-html="$t('intern_bankdata.iban')"></span>
                  <input type="text" class="form-control" name="sepa[iban_new]" v-model.trim="iban" @blur="$v.iban.$touch()" :class="{ 'is-invalid': $v.iban.$error }">
                  <div class="invalid-feedback" v-if="!$v.iban.required">Bitte IBAN eingeben</div>
              </div>
            </div>

            <div>
              <span v-html="$t('intern_bankdata.legal_info')"></span>
            </div>
      </div>

      <span v-if="!sepaInfo">{{$t('intern_rechnung_bezahlen.zahlung_hinweis')}}</span>

      <div class="mt-3">
          <router-link to="/" :exact="true" class="btn btn-ghost">Zurück</router-link>
          <button v-if="sepaInfo" class="btn btn-success float-right" @click="submitMandateAndPay">{{$t('intern_bankdata.button_speichern_und_bezahlen')}}</button>
          <button v-if="!sepaInfo" class="btn btn-success float-right" @click="pay">{{$t('intern_rechnung_bezahlen.button_bezahlen')}}</button>
      </div>
    </div>
</template>

<script>
    import {required} from "vuelidate/lib/validators";

    export default {
        data() {
            return {
                bankname: '',
                owner: '',
                bic: '',
                iban: '',
                sepaInfo: '',
                invoice: [],
                err : null
            }
        },
        props: ['invoice_id'],
        methods: {
            scrollTop() {
                window.scrollTo(0, 0);
            },
            submitMandateAndPay() {
                  this.$store.state.loading = true;
                  const bankdata = {
                    bankname : this.bankname,
                    owner : this.owner,
                    bic : this.bic,
                    iban : this.iban
                  }
                  this.$http.put('invoiceApi/createMandateAndPayInvoice?invoice_id=' + this.invoice_id, bankdata).then(response => {
                    if(response.status == 'success'){
                      const data = JSON.parse(response.data);
                      this.invoice = data.invoice;
                      this.sepa = data.sepa;
                      this.$router.push({ name: 'invoice-payment-submit' , params:{ invoice_id : this.invoice_id}});
                    }
                  }).catch(error => {
                    let data = JSON.parse(error.response.data.data);
                    console.log('submitMandateAndPay error : '+error);
                    this.err = data.msg;
                    this.scrollTop();
                  }).then(() => {
                    this.$store.state.loading = false;
                  });
            },
            pay() {
                  this.$store.state.loading = true;
                  this.$http.put('invoiceApi/createMandateAndPayInvoice?invoice_id=' + this.invoice_id).then(response => {
                    const data = JSON.parse(response.data);
                    this.invoice = data.invoice;
                    this.sepa = data.sepa;
                  }).catch(error => {
                    let data = JSON.parse(error.response.data.data);
                    console.log('pay error : '+error);
                    this.err = data.msg;
                    this.scrollTop();
                  }).then(() => {
                    this.$store.state.loading = false;
                    this.$router.push({ name: 'invoice-payment-submit' , params:{ invoice_id : this.invoice_id}});
                  });
            }
        },
        created() {
          this.$store.state.loading = true;
          this.$http.get('invoiceApi/getInvoice?invoice_id=' + this.invoice_id).then(response => {
               const data = JSON.parse(response.data);
               this.invoice =  data.invoice;
               if(this.invoice.status == 'bezahlt'){
                 //this.$store.state.loading = false;
                 this.$router.push({ name: 'invoice-payment-submit' , params:{ invoice_id : this.invoice_id}});
               }
            }).catch( error => {
                console.log(error);
            }).then(() => {
                this.$store.state.loading = false;
            });

        },
        beforeCreate() {
            document.title = 'Rechnung bezahlen';

            //this.$store.state.loading = true;
            this.$http.get('UserApi/GetSepaInfoStatus').then(response => {
               this.sepaInfo = JSON.parse(response.data);
            }).catch( error => {
                console.log(error);
            }).then(() => {
                this.$store.state.loading = false;
            });
        },
        validations: {
            owner: {required},
            bic: {required},
            iban: {required}
        }
    }
</script>

<style scoped>
.paymentWindow{
    width: 100%;
    height: 700px;
    border: none;
}
.btn-ghost{
  color: #5FA963;
  background-color: #fff !important;
  border-color: #5FA963 !important;
}
.btn-ghost:hover{
  color: #fff;
  background-color: #5FA963 !important;
  border-color: #5FA963 !important;
}
</style>
